import Highcharts from 'highcharts';
import * as roundedCorners from 'highcharts-border-radius';

roundedCorners(Highcharts)

export default Highcharts